import React from 'react';

import styles from '../Status.css';

import Badge from 'elements/Badges/Badge';
import { BADGE_STATUS_COLOR } from 'elements/Badges/constants';

export const CURRENT_VERSION = '1.2.4 (15/10/2018)';

export const COLUMNS = [
  {
    header: 'added',
    key: 'added',
    class: styles.greyCell
  },
  {
    header: 'version',
    key: 'version',
  },
  {
    header: 'status',
    key: 'status'
  }
];

/* eslint-disable react/display-name */
export const FOUNDATIONS_DATA = [
  {
    group: 'Colours',
    added: '6/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['ready']}>ready</Badge>
  },
  {
    group: 'Grids',
    added: '6/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['ready']}>ready</Badge>
  },
  {
    group: 'Icons',
    added: '6/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['ready']}>ready</Badge>
  },
  {
    group: 'Illustrations',
    added: '6/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['ready']}>ready</Badge>
  }
];

/* eslint-disable react/display-name */
export const ELEMENTS_DATA = [
  {
    group: 'Accordions',
    added: '3/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Action Icons',
    added: '24/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Buttons',
    added: '18/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Badges',
    added: '28/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Dividers',
    added: '24/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Footers',
    added: '3/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Inputs',
    added: '15/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Links',
    added: '18/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Loadings',
    added: '24/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Maps',
    added: '3/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Notifications',
    added: '3/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Paginations',
    added: '28/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Tabs',
    added: '18/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Tags',
    added: '27/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Toggles',
    added: '28/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Tooltips',
    added: '28/9/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  }
];

export const COMPONENTS_DATA = [
  {
    group: 'Accordion',
    added: '8/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Banners',
    added: '3/12/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Header',
    added: '15/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Hotspots',
    added: '7/11/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Footer',
    added: '8/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Form',
    added: '15/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Maps',
    added: '8/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Notifications',
    added: '8/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },
  {
    group: 'Vertical Section Marker',
    added: '19/10/2018',
    version: '1.0.0',
    status: <Badge color={BADGE_STATUS_COLOR['under review']}>under review</Badge>
  },

];



// WEBPACK FOOTER //
// ./src/containers/libraryStatus/constants/statusData.js